import { FEATURES } from "../constants";
import styles from "./FeaturesSection.module.css";
import Feature from "./Feature";
import { tempToColor } from "../utils/helpers";
function FeaturesSection({ tempColor }) {
  return (
    <div
      style={{
        backgroundColor: `${tempToColor(tempColor)}`,
      }}
      className={styles["features-section-container"]}
    >
      <h2 className={styles.heading}>Our Product Features</h2>
      <div className={styles["features-container"]}>
        {FEATURES.map((feature) => (
          <Feature
            heading={feature.heading}
            key={feature.id}
            description={feature.description}
            path={feature.path}
            svg={feature.svg}
          ></Feature>
        ))}
      </div>
    </div>
  );
}

export default FeaturesSection;
